import { Colors, ThemedColorsMap } from '../types/Colors'
import { createThemedColors, reverseColors } from '../services/colorService'
export const colors: Colors = {
  gray: {
    0: '#FFFFFF',
    50: '#F6F7F9',
    100: '#E0E5EB',
    200: '#C2CBD6',
    300: '#A3B1C2',
    400: '#858FAD',
    500: '#667399',
    600: '#52637A',
    700: '#52637A',
    800: '#213145',
    900: '',
    1000: '#000000',
  },
  blueish: {
    0: '#FFFFFF',
    50: '#F4F6FC',
    100: '#EBEFF9',
    200: '#D9DFF1',
    300: '#C7D0EB',
    400: '#BBC4DF',
    500: '#A8B4D6',
    600: '#8294C9',
    700: '',
    800: '#455CA1',
    900: '',
    1000: '#000000',
  },
  blue: {
    0: '#FFFFFF',
    50: '#F0FAFF',
    100: '#E3F5FF',
    200: '#CDECFE',
    300: '#B4E3FD',
    400: '#9CDAFC',
    500: '#0479FE',
    600: '',
    700: '',
    800: '#015BC1',
    900: '',
    1000: '#000000',
  },
  red: {
    0: '#FFFFFF',
    50: '#FFF0F0',
    100: '#FFE5E5',
    200: '#FFCCCC',
    300: '#FFB2B2',
    400: '#FF9999',
    500: '#DD6555',
    600: '',
    700: '',
    800: '#A13021',
    900: '',
    1000: '#000000',
  },
  orange: {
    0: '#FFFFFF',
    50: '#FEF7EF',
    100: '#FEE5C9',
    200: '#FDD9AF',
    300: '#FDCE96',
    400: '#FCC27D',
    500: '#FB951E',
    600: '',
    700: '',
    800: '',
    900: '',
    1000: '#000000',
  },
  green: {
    0: '#FFFFFF',
    50: '#F0FFF4',
    100: '#CCFAD9',
    200: '#B5F7C8',
    300: '#9EF5B6',
    400: '#87F2A5',
    500: '#1FBC5E',
    600: '',
    700: '',
    800: '#1BA653',
    900: '',
    1000: '#000000',
  },
  purple: {
    0: '#FFFFFF',
    50: '#F5F3FC',
    100: '#DAD2F4',
    200: '#C9BEEF',
    300: '#B8A9EA',
    400: '#A592E8',
    500: '#7456DC',
    600: '',
    700: '',
    800: '',
    900: '',
    1000: '#000000',
  },
  pink: {
    0: '#FFFFFF',
    50: '#FFF0FB',
    100: '#F4D2EA',
    200: '#EFBEE1',
    300: '#EAA9D8',
    400: '#E892D0',
    500: '#DC56B7',
    600: '',
    700: '',
    800: '',
    900: '',
    1000: '#000000',
  },
  turquoise: {
    0: '#FFFFFF',
    50: '#F3FBFC',
    100: '#D2EFF4',
    200: '#BEE7EF',
    300: '#A9E0EA',
    400: '#92DBE8',
    500: '#40D8F2',
    600: '',
    700: '',
    800: '',
    900: '#204146',
    1000: '#000000',
  },
  yellow: {
    0: '#FFFFFF',
    50: '#FEFBEF',
    100: '#FCF4CA',
    200: '#FAEFB2',
    300: '#F8E99A',
    400: '#FCE87E',
    500: '#FFDE33',
    600: '',
    700: '',
    800: '#C2A300',
    900: '',
    1000: '#000000',
  },
}
export const reversedColors = reverseColors(colors)

export const defaultThemedColorsMap: ThemedColorsMap = {
  'color-1': 'gray',
  'color-2': 'blueish',
  'color-3': 'blue',
  'color-4': 'red',
  'color-5': 'orange',
  'color-6': 'green',
}

export const defaultThemedColors = createThemedColors(defaultThemedColorsMap)
